import { useEffect, useState } from 'react'
import { ExportRail } from '@/components/timetable-export/ExportRail'
import { timetableExportApi, type ExportOptions } from '@/services/api/timetableExport'

export function TimetableExportPage() {
  const [options, setOptions] = useState<ExportOptions | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    timetableExportApi.options().then(setOptions).catch(() => setError('Export konnte nicht geladen werden.'))
  }, [])

  if (!options) return <div className="p-6">{error || 'Laden…'}</div>
  if (!options.can_export) return <div className="p-6">Kein Export-Recht.</div>

  return (
    <div className="p-4">
      <ExportRail options={options} />
    </div>
  )
}
